<template>
    <div class="container">
        <b-tabs content-class="" v-model="activeTab" >
            <b-tab>
                <template #title>
                    Asignación <b-badge variant="primary"></b-badge>
                </template>
                <PreviewMassive 
                    :massiveAssignmenItems="massiveAssignmenItems" 
                    ref="assignationMod" 
                    @close="closeListener" 
                    @done="doneListener" 
                    @openReservation="openReservation"
                >
                </PreviewMassive>
            </b-tab>
            <b-tab title="Data por proveedor">
                <b-row>
                    <b-col>
                        <b-form-group :label="'Proveedor'" label-for="driver-select">
                            <Multiselect
                                label="text"
                                :selectLabel="null"
                                track-by="value"
                                :options="suppliersOpts"
                                v-model="selectedSupplier"
                                @select="selectedSupplierAction"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group :label="'Fecha'" label-for="driver-select">
                            <b-form-datepicker
                                    :locale="$root.store.state.currentUser.lang"
                                    reset-button
                                    size="sm"
                                    v-model="date"
                                    @input="dateChanged"
                                    
                                />
                        </b-form-group>
                    </b-col>
                </b-row>
            
                <div class="container">
                    <hr>
                    <b-tabs content-class="mt-3" align="center">
                        <b-tab  active>
                            <template #title> Rides <b v-if="rides.rows.length>0">{{rides.rows.length}}</b> </template>
                            <b-alert variant="info" v-if="$root.isEmpty(selectedSupplier)" show class="text-center">
                                Seleccione un Proveedor para mostrar su operación
                            </b-alert> 
                            <b-alert variant="warning" v-if="!$root.isEmpty(selectedSupplier) && !loading && $root.isEmpty(rides.rows)" show class="text-center">
                                No hay rides asignados al proveedor: <b>{{ selectedSupplier.name }}</b>
                            </b-alert>
                            <section v-if="!$root.isEmpty(selectedSupplier)" class="mb-5"> 
                                <b-card v-for="(ride, index) in rides.rows" :key="index" class="mb-1 p-1 ride-list" :class="{ 'striped': index % 2 !== 0 }" >
                                    <b-row>
                                        <b-col>
                                            <p class="text-secondary">
                                                <b-badge variant="success" v-if="ride.supplierConfirmation=='confirmed'">{{ ride.supplierConfirmation }}</b-badge>
                                                <b-badge variant="warning" v-else>{{ ride.supplierConfirmation }}</b-badge>
                                            </p>
                                        </b-col>
                                        <b-col>
                                            <p class="text-right mr-3 mb-2 text-primary"><md-icon :icon="tripIcon(ride)"/>
                                                <a href="#" @click="openReservation(ride)" class="text-primary">{{ ride.serviceNumber }}</a>
                                                | <b-badge :variant="getVariantBystatus(ride.status)">{{ride.status}}</b-badge>
                                            </p>
                                        </b-col>
                                    </b-row>
                                    <!-- Driver and Vehicle Info -->
                                    <b-row class="mt-2 align-items-center">
                                        <b-col class="col-12 col-md-6">
                                            <p class="mb-0">
                                                <b>Driver:</b>
                                                <a href="#" class="text-info">
                                                    {{ getDriverFromRide(ride)}}
                                                </a>
                                            </p>
                                        </b-col>
                                        <b-col class="col-12 col-md-6">
                                            <p class="mb-0">
                                                <b class="text-sm">Unidad:</b> <small>{{ getUnitFromRide(ride) }}</small> 
                                            </p>
                                        </b-col>
                                    </b-row>
                                    <p><b>Client name:</b> {{ ride.reservation.client.firstName }}  {{ ride.reservation.client.lastName }}</p>
                                    <p><b>Pickup Date:</b> {{ ride.pickupDatetime }}</p>
                                    <p><b>pickup:</b> {{ ride.pickup.name }}</p>
                                    <p><b>Dropoff:</b> {{ ride.dropoff.name }}</p>
                                    <p><b>h:</b> {{ ride.supplier.name }}</p>
                                </b-card>
                            </section>
                        </b-tab>
                        <b-tab title="Rides selected" v-if="false"><p></p></b-tab>
                    </b-tabs>
                </div>
            </b-tab>
            
        </b-tabs>
        <b-overlay :show="loading" no-wrap></b-overlay>
        
        <FormReservation
			:model-id="resMod.modelId"
			:copy-from-id="resMod.modelId"
			:formTypeWork="'viewForm'"
			@changeId="resMod.modelId = $event"
			v-model="resMod.show"
		/>
    </div>
  </template>
  
  <script>
import moment from 'moment';
import PreviewMassive from "./partials/PreviewMassiveAssignment.vue"
import Multiselect from "vue-multiselect";
import FormReservation from "@/components/sections/reservation/formReservation/index";
export default {
    name: 'AssignmentTool',
    components: {PreviewMassive,Multiselect,FormReservation},
    props: {
		ridesSelected: {
			type: Array,
			required: false
		},
        massiveAssignmenItems:{
			type: Array,
			required: false
		}
	},
    data() {
        return {
            selectedSupplier: null,
            loading: false,
            rides:{rows:[]},
            resume:{rows:[]},
            date: moment().format("YYYY-MM-DD"),
            fields:{
                resume:[
                    { key: 'driver', label: "Conductor"},
                    { key: 'count', label: "Asignados"},
                ]
            },
            activeTab:1,
            resMod:{
                modelId:-1,
                show:false
            }
        };
    },
    computed:{
        localRidesSelected(){
            if(this.$root.isEmpty(this.ridesSelected)) return [];
            return this.ridesSelected;
        },
        suppliersOpts() {
			let aux = JSON.parse(JSON.stringify(this.$root.auxVars.suppliersOpts));
			return aux;
		},
    },
    methods: {
        getDriverFromRide(ride){
            if(this.$root.isEmpty(ride.driver)) return '--';
            return ride.driver.firstName+" "+ride.driver.lastName
        },
        getUnitFromRide(ride){
            if(this.$root.isEmpty(ride.transportUnit)) return '--';
            return ride.transportUnit.title;
        },  
        tripIcon(rideModel) {
			if (rideModel.pickup.isAirport) return "flight_land";
			//A2H
			else if (rideModel.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
        openReservation(rideModel){
            this.resMod.modelId = rideModel.reservationId;
            this.resMod.show    = true;
		},
        async dateChanged(){
            this.search();
        },
        async getRides(){
            try{
                let params={
                    filters:{
                        supplier:[this.selectedSupplier.id],
                        pickupStartDate:this.date,
                        pickupEndDate:this.date
                    },
                    limit:500,
                    offset:0,
                    sortBy:"pickupDatetime",
                    sortOrder:'ASC'
                }
                const response = await this.$root.api
                .get(`/assignment/tool/transport-services`,{params:params})
                return response.data;
            }catch(error){
                console.error('Error fetching rides:', error);
                return []; // Return an empty array in case of error
            }
        },
        async search(){
            if(this.$root.isEmpty(this.selectedSupplier)) return;
            this.loading = true;
            this.rides = await this.getRides();
            this.loading=false;
        },
       
        getVariantBystatus(status){
			try{
				let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
					return el.value==status
				});
				if(variant) return variant.class;
			}catch(err){console.log(err)}
			return "info";
		},
        showModuleAssignation(){
            this.activeTab=0;
            setTimeout(() => {
                this.$refs["assignationMod"].load();
            },0);
           
        },
        doneListener(payload){
            this.$emit("done",payload)
        },
        closeListener(payload){
            this.$emit("close",payload)
        },
        selectedSupplierAction(selected){
            this.selectedSupplier = selected
            this.search();
        }
    },
    mounted(){
        this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts"]
		});
    }
  };
  </script>
<style scoped>
    .ride-list{
        padding: 10px;
        overflow-y: scroll;
        /*height: 600px;*/
        background: #f7f7f7;
        border-radius: 1rem;
    }
    .card-body{
        padding: 5px !important;
    }
    p{
        margin: 0.5px;
        font-size: smaller;
    }
    .card{
        border-radius: 1.5rem !important;
    }
    .striped{
        background-color: #f4f8fc;
    }
    label{
        margin-bottom: unset !important;
    }
</style>
  